//----------------------
// AUTO-GENERATED by nswag/split-service-proxies.js - do not edit by hand.
// Source: NSwag output; legacy declarations live in ./service-proxies.ts (frozen).
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

/** Providers for services generated after service-proxies.ts was frozen. Spread into ServiceProxyModule. */
export const NEW_SERVICE_PROXIES = [];
// generated-hash: 43b813d84d8ef39dfdac1e60153a01b78531650fdbd46134dd9cde739ee84c0f
